module.exports = __webpack_public_path__ + "img/language-classes.75e0e0ba.png";